import { Button, Icon, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiChevronDown, FiFileText } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { SourcingEventV2Dto, useListPublicBidsForEventQuery } from "../../../autogen/bff-api";
import { contractUrl } from "./contractUrl";

export const GoToContractButton = ({ event }: { event: SourcingEventV2Dto }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const contractIds = event.award?.contractIds ?? [];
  const { data } = useListPublicBidsForEventQuery({ eventId: event.id }, { skip: contractIds.length === 0 });

  if (contractIds.length === 0) return null;

  const bidByContractId = new Map(
    (data?.bids ?? []).filter((bid) => bid.contractId).map((bid) => [bid.contractId as string, bid]),
  );
  const isResolving = !data;
  const goToContract = (contractId: string) =>
    navigate(contractUrl(contractId, bidByContractId.get(contractId)?.contractState, event.id));

  if (contractIds.length === 1) {
    return (
      <Button
        size="sm"
        colorScheme="teal"
        leftIcon={<Icon as={FiFileText} />}
        isDisabled={isResolving}
        onClick={() => goToContract(contractIds[0])}
      >
        {t("Go to contract")}
      </Button>
    );
  }

  return (
    <Menu>
      <MenuButton
        as={Button}
        size="sm"
        colorScheme="teal"
        leftIcon={<Icon as={FiFileText} />}
        rightIcon={<Icon as={FiChevronDown} />}
        isDisabled={isResolving}
      >
        {t("Go to contract")}
      </MenuButton>
      <MenuList>
        {contractIds.map((contractId) => (
          <MenuItem key={contractId} onClick={() => goToContract(contractId)}>
            {bidByContractId.get(contractId)?.ownerName || t("Unknown")}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
